<template>
  <div
      class="x-standard-shadow"
      selenium="pro-card-container">
    <transition name="fade" mode="out-in">
      <div
          v-if="publicProfile"
          class="PRO-CARD layout">
        <div class="layout-item flex-0-0">
          <div class="PRO-CARD-GUTTER">

            <div class="d-flex fd-column jc-around ">
              <div class="WHITEBACKGROUND">
                <vk-icon
                    class="ai-center"
                    v-tooltip="{
                      content: insuranceInfo.isInsured
                        ? `Insured $${formatNumber(insuranceInfo.amount)}`
                        : '',
                    }"
                    :name="insuranceInfo.isInsured ? 'insured' : 'insured-inactive'"
                    size="27"
                    selenium="pro-card-insured-icon"/>
              </div>
              <div class="WHITEBACKGROUND">
                <vk-icon
                    class="ai-center"
                    v-tooltip="{
                      content: licenseInfo.isLicensed
                        ? `License number: ${
                          licenseInfo.licenses[0].document_identifier
                        }`
                        : '',
                    }"
                    :name="licenseInfo.isLicensed ? 'certfied' : 'certfied-inactive'"
                    size="27"
                    selenium="pro-card-license-icon"/>
              </div>
              <div  class="MATCHSTATUSVIEW as-center">
                <img
                    class="m-l-1"
                    width="14"
                    height="14"
                    src="@/assets/CheckCircle.svg"
                    alt="Status check"
                />
                <div class="STATUSTEXT">{{ $options.MATCH_STATUS_LABELS[match.match_status] }}</div>

              </div>

            </div>

            <pro-avatar
                class="AVATAR-IMAGE"
                :image="publicProfile.service_provider.logo"
                :size="$device.isMobile ? 75 : 85"
                selenium="pro-card-avatar">


            </pro-avatar>
            <img
                v-if="isTopPro"
                v-tooltip="{
                  targetClasses: 'c-white',
                  content: 'Verified top performance.',
                }"
                class="BADGE"
                src="@/assets/TopPro.svg"
                height="24"
                width="24"
                alt="Top Pro badge"
            >
            <img
                v-else-if="publicProfile.rating_average >= 4.5"
                v-tooltip="{
                  targetClasses: 'c-white',
                  content: 'Pros with a 5-star rating.',
                }"
                class="BADGE"
                src="@/assets/FiveStarPro.svg"
                height="24"
                width="24"
                alt="Five Star Pro badge"
                selenium="public-profile-five-stars-badge"
            >

          </div>
        </div>
        <div class="layout-item">
          <div class="h-100 d-flex fd-column jc-between ai-start ov-auto p-1 m-l-2 m-l-4:mo">
            <div>
              <div
                  v-tooltip="{
                    content: publicProfile.service_provider.business_name
                  }"
                  class="TEXTNAME"
                  selenium="pro-card-business-label">
                {{ publicProfile.service_provider.business_name }}
              </div>
              <div>
                <div
                    v-if="showContactPricing"
                    class="TEXTPRICINGCONTACT"
                    selenium="pro-card-business-label">
                  Contact for Pricing
                </div>
                <div
                    v-else-if="showSinglePrice"
                    class="TEXTPRICING d-flex "
                    selenium="pro-card-business-label">
                  ${{ pricingInfo.minimum_price }}
                  <div class="TEXTPRICINGRATE">
                    / {{ pricingInfo.unit }}
                  </div>
                </div>
                <div
                    v-else
                    class="TEXTPRICING d-flex "
                    selenium="pro-card-business-label">
                  ${{ pricingInfo.minimum_price }}-${{ pricingInfo.maximum_price }}
                  <div class="TEXTPRICINGRATE">
                    /  {{ pricingInfo.unit }}
                  </div>
                </div>
              </div>

              <div
                  v-if="businessAddress"
                  class="TEXTADDRESS d-flex ai-center"
                  selenium="pro-card-city-state-label">
                <vk-icon name="pin" class="c-depot m-r-1" size="12"/>
                {{ businessAddress.city }},
                {{ businessAddress.state }} {{ businessAddress.zipcode }}
              </div>

              <div class="BOTTOMVIEW d-flex">


                <button
                    class="MESSAGE btn-secondary btn-sm"
                    :class="{ 'HAS-UNREAD': hasUnreadMessage }"
                    selenium="pro-card-send-message"
                    @click.stop="$emit('sendMessage')">
                  <span
                      v-if="hasUnreadMessage && showUnreadDot"
                      class="UNREAD-DOT"
                      selenium="pro-card-unread-dot"/>
                  <a class="MESSAGETEXT">
                    {{ hasUnreadMessage ? 'New Message' : 'Message' }}
                  </a>
                </button>
                <div
                    v-if="showReview"
                    class="MESSAGETEXT as-center m-l-1"
                    selenium="pro-card-leave-review"
                    :target="[$device.isMobileOrTablet ? '_self' : '_blank']"
                    @click.stop="
                      $emit('leaveFeedback', {
                        skillsProfileId: match.service_provider_user_identifier,
                      })
                    ">
                  {{ hasReview ? 'See' : 'Leave' }} Review
                </div>

                <router-link
                    class="MESSAGETEXT as-center m-l-1 "
                    :target="[$device.isMobileOrTablet ? '_self' : '_blank']"
                    :to="{
                      name: 'pro-public-profile',
                      params: { serviceProviderOccupationId: publicProfile.id }
                }">
                  View Profile
                </router-link>

              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="PRO-CARD-GHOST">
        <loading-indicator :size="30" />
      </div>
    </transition>
  </div>
</template>

<script>
import workOrder from '@/mixins/work-order';
import publicProfileMixin from '@/mixins/public-profile';
import formatNumber from '@/filters/format-number';

export default {
  name: 'pro-card',
  mixins: [
    workOrder,
    publicProfileMixin,
  ],
  props: {
    match: {
      type: Object,
      required: true,
    },
    hasReview: {
      type: Boolean,
      default: false,
    },
    serviceDisplayName: {
      type: String,
      required: true,
    },
    hasUnreadMessage: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    // A/B variant: append ?unreadDot=1 to show a green dot next to "New Message"
    showUnreadDot () {
      return this.$route.query.unreadDot === '1';
    },

    credentials () {
      return this.$store.getters['jobrequest/matches/publicProfileCredentials'](this.publicProfile.id);
    },
    showBadge () {
      return this.match.match_status === this.$options.MATCH_STATUSES.HIRED
        || this.match.match_status === this.$options.MATCH_STATUSES.COMPLETED;
    },
    // Used by publicProfile mixin
    serviceProviderUserIdentifier () {
      return this.match.service_provider_user_identifier;
    },
    // Used by publicProfile mixin
    serviceProviderOccupationId () {
      return this.match.occupation_id;
    },
    isFiveStar () {
      return this.ratingAverage >= 4.5;
    },
    isTopPro () {
      return JSON.parse(this.topPro);
    },

    pricingInfo () {
      return this.publicProfile.services.find(o => o.name === this.serviceDisplayName);
    },
    showReview () {
      return this.match.match_status !== this.$options.MATCH_STATUSES.UNREPLIED
        && this.match.match_status !== this.$options.MATCH_STATUSES.UNRESPONSIVE
        && this.match.match_status !== this.$options.MATCH_STATUSES.REJECTED;
    },
    showContactPricing () {
      return !this.pricingInfo.unit
             || !this.pricingInfo.minimum_price
             || !this.pricingInfo.maximum_price;
    },
    showSinglePrice () {
      return this.pricingInfo.unit
             && this.pricingInfo.minimum_price
             && this.pricingInfo.maximum_price
             && this.pricingInfo.maximum_price === this.pricingInfo.minimum_price;
    },
  },
  mounted () {
    if (this.isTopPro !== null) {
      this.$emit('updateTopPro');
    }
  },
  methods: {
    formatNumber,
  },
};
</script>

<style lang="scss" scoped>
  @import "~@homeservices/design-kit/tools.scss";
  $card-height: 145px;
  $card-border: 1px solid $color-gray40;

  .PRO-CARD {
    transition: border-color $transition-speed-standard;
    height: $card-height;
    min-height: $card-height;
    flex-wrap: nowrap;
    border: $card-border;
    position: relative;
    user-select: none;
  }

  .PRO-CARD-GUTTER {
    display: flex;
    width: 105px;
    height: 100%;
    flex-direction: row;
    background-color:#F96302;
    @include padding-left(1);


    @include mobile-only {
      width: 82px;
    }
  }
  .AVATAR-IMAGE {
      position: absolute;
      left: 40%;
      top: 5%;
      @include mobile-only {
     left: 45%;
     top: 7%;

    }
    }

  .PRO-CARD-GHOST {
    height: $card-height;
    min-height: $card-height;
    display: flex;
    align-items: center;
    justify-content: center;
    border: $card-border;
  }

  .REJECTED-OVERLAY {
    @include absolute(auto, 0, 0, 0);
    @include padding(1 2);
    border: 2px solid $color-red;
    color: $color-red;
    background: white;
  }

  .MATCH-STATUS {
    @include text-medium;
    color: $color-green;
    border: 1px solid $color-green;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    border-radius: 100px;
    min-width: 100px;
    height: 24px;
    text-transform: uppercase;

  }

  .ACTION-ITEMS {
    display: grid;
    grid-gap: $unit;
    grid-template: '.' auto
                   '.' auto /
                    1fr ;

    @include desktop {
      grid-template: '.   .' auto /
                      1fr 1fr;
      }
    }
    .MATCHSTATUSVIEW{
      width: 92px;
      height: 24px;
      flex-direction: row;
      display: flex;
      background-color: #001529;
      border-top-left-radius: 15px;
      border-bottom-left-radius: 15px;
      border-top-right-radius: 15px;
      border-bottom-right-radius: 15px;
      align-items: center;
      @include mobile-only {
      width: 70px;
      background-color: #001529;
      display: flex;
      align-items: center;
    }

    }
    .STATUSTEXT{
      font-size: 12px;
      font-weight: 400;
      color: white;
      margin-left: 4px;
      text-transform: capitalize;
      @include mobile-only {
        font-size: 8px;
        text-transform: capitalize;
    }


    }
    .WHITEBACKGROUND{
      display: flex;
    height: 30px;
    width: 30px;
    border-radius:15px ;
    background-color: white;
    align-items: center;
    justify-content: center;
  }
  .BADGE {
    position: absolute;
    left: 100px;
    top: 70px;

    @include desktop {
      bottom: 45%;
    }

    @include mobile-only {
      position: absolute;
    left: 90px;
    top: 60px;
    }
  }
  .TEXTNAME{
    font-size: 15px;
    font-weight: 700;
    color: #333333;
    text-transform: capitalize;
    overflow: hidden;
   text-overflow: ellipsis;
   display: -webkit-box;
   -webkit-line-clamp: 2;
   -webkit-box-orient: vertical;
   }
  .TEXTPRICING{
    font-size: 19px;
    font-weight: 700;
    color: #1E1E1E;

  }
  .TEXTPRICINGCONTACT{
    font-size: 16px;
    font-weight: 400;
    color: #1E1E1E;

  }
  .TEXTPRICINGRATE{
    font-size: 12px;
    font-weight: 400;
    color: #1E1E1E;
    align-self: center;
    margin-left: 3px;

  }
  .TEXTADDRESS{
    font-size: 12px;
    font-weight: 400;
    color: #333333;
  }
  .MESSAGE{
    height: 25px;
    min-width: 65px;
    padding: 0 8px;
    border-radius: 2px;
    white-space: nowrap;
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }
  .UNREAD-DOT{
    width: 8px;
    height: 8px;
    margin-right: 4px;
    border-radius: 50%;
    background-color: $color-green;
  }
  .MESSAGETEXT{
    align-self: center;
    font-size: 10px;
    font-weight: 700;
    color: #F96302;
    cursor: pointer;
  }
  .BOTTOMVIEW{
    position: absolute;
    bottom: 6px;
  }
</style>
